import { Swiper, Thumbs, Navigation } from 'swiper';
import { elementExists } from '../../core/utils';
import eventBus from '../../core/services/event-bus';

const ProductSingleImages = function () {
  Swiper.use([Thumbs, Navigation]);

  const swiperProduct = document.querySelector('.product-single__images');
  if (elementExists(swiperProduct)) {
    const swiperProductThumb = swiperProduct.querySelector(
      '.swiper-product-thumbs',
    );
    const swiperProductMain = swiperProduct.querySelector(
      '.swiper-product-main',
    );

    let swiperThumbs = null;
    let swiperMain = null;
    const hasThumbs = elementExists(swiperProductThumb);

    if (elementExists(swiperProductMain)) {
      if (hasThumbs) {
        swiperThumbs = new Swiper(swiperProductThumb, {
          slidesPerView: 3,
          spaceBetween: 16,
          slideToClickedSlide: true,
          watchSlidesProgress: true,
          loop: true,
        });
      }

      swiperMain = new Swiper(swiperProductMain, {
        slidesPerView: 1,
        spaceBetween: 24,
        allowTouchMove: true,
        loop: true,
        thumbs: {
          swiper: swiperThumbs,
        },
        navigation: {
          nextEl: '.swiper-product-main .swiper-button-next',
          prevEl: '.swiper-product-main .swiper-button-prev',
        },
      });

      window.addEventListener('resize', function () {
        swiperMain?.update();
        swiperThumbs?.update();
      });

      eventBus.on(eventBus.types.OptionsSelected, function (event) {
        const variantId = event.detail.id;
        const imageSlides = swiperProductMain.querySelectorAll(
          '.swiper-slide:not(.swiper-slide-duplicate)',
        );
        imageSlides.forEach((el) => {
          const data = el.dataset;
          if (data.variantIds) {
            if (data.variantIds.indexOf(variantId) > -1) {
              swiperMain.slideToLoop(data.swiperSlideIndex, 0);
            }
          }
        });
      });
    }
  }
};

export default ProductSingleImages;
